module.exports = __webpack_public_path__ + "static/media/PLT-Logo.2f50226f.png";